/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notes_Switch_LabelInputs */



/**
* | output |
* | --- |
* | "Notetaker" |
*
* @param {Meeting_Notes_Switch_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notes_switch_label = /** @type {((inputs?: Meeting_Notes_Switch_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notes_Switch_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notetaker")
	return /** @type {LocalizedString} */ ("Notetaker")
});